(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const RM = matchMedia('(prefers-reduced-motion: reduce)');

  // Red de seguridad: el CSS deja el body en opacity 0 hasta que esto corre.
  // Si algo de aqui abajo fallara, el body se enciende igual por animacion.
  requestAnimationFrame(() => document.body.classList.add('ready'));

  /* ---------- menu de categorias en movil ---------- */
  (() => {
    const btn = $('.dl-head__burger');
    const cats = $('.dl-head__cats');
    if (!btn || !cats) return;
    const velo = $('.dl-head__velo');
    const cerrar = $('.dl-head__cerrar', cats);

    const abrir = (si) => {
      cats.classList.toggle('abierto', si);
      btn.classList.toggle('es-x', si);
      btn.setAttribute('aria-expanded', String(si));
      document.body.classList.toggle('dl-sin-scroll', si);
      if (velo) velo.hidden = !si;
      // Al cerrar, el foco vuelve al boton que lo abrio.
      if (!si && document.activeElement && cats.contains(document.activeElement)) btn.focus();
    };

    btn.addEventListener('click', () => abrir(!cats.classList.contains('abierto')));
    if (velo) velo.addEventListener('click', () => abrir(false));
    if (cerrar) cerrar.addEventListener('click', () => abrir(false));
    // Al elegir una categoria el cajon se cierra solo.
    cats.addEventListener('click', e => { if (e.target.closest('a')) abrir(false); });
    addEventListener('keydown', e => { if (e.key === 'Escape') abrir(false); });
    // Si se gira el movil o se pasa a escritorio, el cajon vuelve a su sitio.
    matchMedia('(min-width:861px)').addEventListener('change', e => { if (e.matches) abrir(false); });
  })();

  /* ---------- carrusel del hero ---------- */
  (() => {
    const hero = $('[data-hero]');
    if (!hero) return;
    const slides = $$('.dl-hero__slide', hero);
    if (!slides.length) return;
    const puntos = $$('.dl-hero__punto', hero);
    let i = 0, timer = null;

    function ir(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const activa = k === i;
        s.classList.toggle('es-activa', activa);
        s.setAttribute('aria-hidden', String(!activa));
        // Lo que no se ve tampoco se tabula.
        $$('a, button', s).forEach(el => { el.tabIndex = activa ? 0 : -1; });
      });
      puntos.forEach((p, k) => {
        p.classList.toggle('es-activo', k === i);
        p.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }

    function parar() { if (timer) { clearInterval(timer); timer = null; } }
    function arrancar() {
      parar();
      if (RM.matches || slides.length < 2) return;
      timer = setInterval(() => ir(i + 1), 6500);
    }

    const prev = $('.dl-hero__fl--prev', hero);
    const next = $('.dl-hero__fl--next', hero);
    if (prev) prev.addEventListener('click', () => { ir(i - 1); arrancar(); });
    if (next) next.addEventListener('click', () => { ir(i + 1); arrancar(); });
    puntos.forEach((p, k) => p.addEventListener('click', () => { ir(k); arrancar(); }));

    hero.addEventListener('mouseenter', parar);
    hero.addEventListener('mouseleave', arrancar);
    hero.addEventListener('focusin', parar);
    document.addEventListener('visibilitychange', () => (document.hidden ? parar() : arrancar()));
    RM.addEventListener('change', arrancar);

    // Deslizar con el dedo, que es como se va a usar de verdad.
    let x0 = null;
    hero.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; parar(); }, { passive: true });
    hero.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) ir(dx < 0 ? i + 1 : i - 1);
      x0 = null;
      arrancar();
    }, { passive: true });

    ir(0);
    arrancar();
  })();

  /* ---------- la cesta, en un panel lateral ---------- */
  (() => {
    const caja = $('[data-cesta]');
    if (!caja) return;
    const cuerpo = $('[data-cesta-cuerpo]', caja);
    const pie = $('[data-cesta-pie]', caja);
    const elTotal = $('[data-cesta-total]', caja);
    const elEnvio = $('[data-cesta-envio]', caja);
    const enlaceCesta = $('.dl-head__cesta');

    const GRATIS = 6000; // 60 € en centimos, igual que la regla de envio
    const euros = (c) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(c / 100);

    // El pack de dos prendas. Lo pone dl-carrito solo a partir del 5/11.
    const PACK = Number(caja.dataset.pack) || 0;

    function mensajePack(cesta) {
      if (!PACK) return '';
      if (cesta.item_count < 2) {
        return `<p class="dl-cesta__pack">Añade otra prenda y te llevas un <strong>${PACK} %</strong> menos.</p>`;
      }
      // Con dos o mas NO damos por hecho el descuento: lo leemos del
      // carrito. Shopify aplica los descuentos automaticos aqui, asi que
      // si esta, esta. Y si fallara, no prometemos un ahorro que luego el
      // pago no haria. Es el unico mensaje de la tienda con dinero
      // de por medio y no se puede permitir ir por libre.
      if (cesta.total_discount > 0) {
        return `<p class="dl-cesta__pack es-logrado">Pack de dos prendas: ahorras <strong>${euros(cesta.total_discount)}</strong>.</p>`;
      }
      return `<p class="dl-cesta__pack es-logrado">El ${PACK} % del pack se aplica al pagar.</p>`;
    }

    let abierta = false;
    function abrir(si) {
      abierta = si;
      caja.hidden = !si;
      document.body.classList.toggle('dl-sin-scroll', si);
      if (si) {
        requestAnimationFrame(() => caja.classList.add('es-visible'));
        const x = $('.dl-cesta__x', caja);
        if (x) x.focus();
      } else {
        caja.classList.remove('es-visible');
      }
    }

    $$('[data-cesta-cerrar]', caja).forEach(b => b.addEventListener('click', () => abrir(false)));
    addEventListener('keydown', e => { if (e.key === 'Escape' && abierta) abrir(false); });

    function contador(n) {
      if (!enlaceCesta) return;
      let b = $('.dl-head__n', enlaceCesta);
      if (n > 0) {
        if (!b) { b = document.createElement('span'); b.className = 'dl-head__n'; enlaceCesta.appendChild(b); }
        b.textContent = n;
      } else if (b) {
        b.remove();
      }
    }

    function pintar(cesta) {
      contador(cesta.item_count);

      if (!cesta.item_count) {
        cuerpo.innerHTML = '<p class="dl-cesta__vacia">Todavía no has añadido nada.</p>';
        pie.hidden = true;
        return;
      }

      cuerpo.innerHTML = cesta.items.map((it, i) => {
        const foto = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        // "Beige / S" sobra cuando la prenda no tiene variantes de verdad
        const variante = it.variant_title ? `<span class="dl-cesta__var">${it.variant_title}</span>` : '';
        return `<article class="dl-cesta__it">
          <a class="dl-cesta__foto" href="${it.url}">${foto ? `<img src="${foto}" alt="" width="80" height="100" loading="lazy">` : ''}</a>
          <div class="dl-cesta__datos">
            <a class="dl-cesta__nombre" href="${it.url}">${it.product_title}</a>
            ${variante}
            <span class="dl-cesta__precio">${it.quantity > 1 ? it.quantity + ' × ' : ''}${euros(it.price)}</span>
            <button class="dl-cesta__quitar" type="button" data-quitar="${i + 1}">Quitar</button>
          </div>
        </article>`;
      }).join('');

      elTotal.textContent = euros(cesta.total_price);
      const falta = GRATIS - cesta.total_price;
      let envio;
      if (falta > 0) {
        const pct = Math.max(4, Math.round((cesta.total_price / GRATIS) * 100));
        envio = `<p>Te faltan <strong>${euros(falta)}</strong> para el envío gratis.</p>
          <span class="dl-cesta__barra"><i style="width:${pct}%"></i></span>`;
      } else {
        envio = '<p class="dl-cesta__logrado">Envío gratis conseguido.</p>';
      }
      elEnvio.innerHTML = mensajePack(cesta) + envio;
      pie.hidden = false;

      $$('[data-quitar]', cuerpo).forEach(b => b.addEventListener('click', () => cambiar(+b.dataset.quitar, 0)));
    }

    async function traer() {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      pintar(await r.json());
    }

    async function cambiar(linea, cantidad) {
      cuerpo.classList.add('esta-ocupada');
      try {
        const r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: linea, quantity: cantidad })
        });
        pintar(await r.json());
      } finally {
        cuerpo.classList.remove('esta-ocupada');
      }
    }

    // El icono de la cesta abre el panel en vez de cambiar de pagina.
    if (enlaceCesta) {
      enlaceCesta.addEventListener('click', e => {
        e.preventDefault();
        abrir(true);
        traer();
      });
    }

    // "Anadir a la cesta" sin salir de la ficha.
    $$('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('[type=submit]');
        const texto = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo...'; }
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          });
          if (!r.ok) throw new Error('no se pudo anadir');
          abrir(true);
          await traer();
        } catch (err) {
          // Si algo falla nos vamos a la pagina de carrito de toda la vida,
          // que es lo que pasaba antes: mejor eso que quedarse sin comprar.
          form.submit();
          return;
        } finally {
          if (btn) { btn.disabled = false; btn.textContent = texto; }
        }
      });
    });
  })();

  /* ---------- tiras horizontales de prendas ---------- */
  $$('[data-tira]').forEach(tira => {
    const pista = $('[data-tira-pista]', tira);
    const prev = $('.tira__fl--prev', tira);
    const next = $('.tira__fl--next', tira);
    if (!pista || !prev || !next) return;

    // Un "paso" es lo que mide una prenda mas su hueco.
    const paso = () => {
      const card = pista.firstElementChild;
      if (!card) return pista.clientWidth;
      const gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    const mover = (signo) => pista.scrollBy({ left: signo * paso() * 2, behavior: 'smooth' });

    prev.addEventListener('click', () => mover(-1));
    next.addEventListener('click', () => mover(1));

    // Las flechas se esconden cuando ya no hay nada hacia ese lado.
    const pintar = () => {
      // Holgura generosa: el ajuste automatico deja el scroll en el valor del
      // padding lateral, no en cero, y la flecha de atras se quedaba visible.
      const holgura = parseFloat(getComputedStyle(pista).paddingLeft) + 4 || 6;
      const max = pista.scrollWidth - pista.clientWidth - 4;
      prev.disabled = pista.scrollLeft <= holgura;
      next.disabled = pista.scrollLeft >= max;
    };
    pista.addEventListener('scroll', pintar, { passive: true });
    addEventListener('resize', pintar);
    pintar();
    // Las fotos van en lazy: al cargarse cambia el ancho total.
    setTimeout(pintar, 800);
  });

  /* ---------- entradas y elementos vivos ---------- */
  // OJO con el umbral: estaba en 0.18, o sea "cuando se vea el 18 % de la
  // seccion". La rejilla de 23 prendas mide varios miles de pixeles, asi que
  // en una pantalla estrecha ese 18 % no cabe NUNCA, la clase 'in' no se
  // ponia y la seccion se quedaba invisible para siempre. Con 0 basta con que
  // asome un pixel.
  const revealIO = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target;
    el.classList.add('in');
    revealIO.unobserve(el);
    setTimeout(() => el.classList.add('settled'), 1800);
  }), { threshold: 0, rootMargin: '0px 0px -5% 0px' });
  const porRevelar = $$('[data-reveal]');
  porRevelar.forEach(el => revealIO.observe(el));
  // Red de seguridad: si por lo que sea el observador no llega a disparar,
  // a los 3 segundos se enseña todo igualmente. Nunca una seccion en blanco.
  setTimeout(() => porRevelar.forEach(el => el.classList.add('in', 'settled')), 3000);

  const liveIO = new IntersectionObserver(es => es.forEach(e => e.target.classList.toggle('live', e.isIntersecting)));
  $$('[data-live]').forEach(el => liveIO.observe(el));

  document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));

  /* ---------- la luna que se mantiene pulsada ---------- */
  (() => {
    const luna = $('.luna');
    const holdBtn = luna && $('.hold', luna);
    const holdLabel = $('#hold-l');
    if (!luna || !holdBtn || !holdLabel) return;

    let hp = 0, holding = false, holdRaf = null, holdLast = 0, holdDone = false, hpShown = -1;

    function writeHold() {
      const v = Math.round(hp * 1000) / 1000;
      if (v !== hpShown) { hpShown = v; holdBtn.style.setProperty('--hp', v); }
    }
    function finishHold() {
      holdDone = true; holding = false; hp = 1; writeHold();
      luna.classList.add('done');
      holdBtn.setAttribute('aria-pressed', 'true');
      holdLabel.textContent = 'Luna llena';
      setTimeout(() => luna.classList.add('settled'), 1200);
    }
    function holdTick(now) {
      const dt = Math.min(64, now - (holdLast || now));
      holdLast = now;
      if (holding) hp = Math.min(1, hp + dt / 1700);
      else hp = hp * Math.pow(0.9, dt / 16.667);
      if (hp >= 1 && holding) { finishHold(); }
      writeHold();
      if (!holdDone && (holding || hp > 0.002)) holdRaf = requestAnimationFrame(holdTick);
      else { if (!holdDone && hp <= 0.002) { hp = 0; writeHold(); } holdRaf = null; holdLast = 0; }
    }
    function startHold(e) {
      if (holdDone) return;
      if (e && e.cancelable) e.preventDefault();
      if (RM.matches) { finishHold(); return; }
      holding = true;
      if (holdRaf === null) holdRaf = requestAnimationFrame(holdTick);
    }
    const endHold = () => { holding = false; };

    holdBtn.addEventListener('pointerdown', e => { if (holdBtn.setPointerCapture) holdBtn.setPointerCapture(e.pointerId); startHold(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(t => holdBtn.addEventListener(t, endHold));
    holdBtn.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) startHold(e); });
    holdBtn.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') endHold(); });
    holdBtn.addEventListener('contextmenu', e => e.preventDefault());

    if (RM.matches) finishHold();
  })();

  /* ---------- preguntas frecuentes ---------- */
  $$('.qa button').forEach(btn => btn.addEventListener('click', () => {
    const qa = btn.parentElement;
    const open = !qa.classList.contains('open');
    qa.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', String(open));
  }));

  /* ---------- formulario de avisos: se revisa aqui y lo envia Shopify ---------- */
  const form = $('#dl-aviso-form');
  const emailInput = form && form.querySelector('input[type=email]');
  if (form && emailInput) {
    const err = form.querySelector('.err');
    const submitBtn = form.querySelector('button[type=submit]');
    form.addEventListener('submit', e => {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailInput.value.trim())) {
        e.preventDefault();
        err.textContent = 'Revisa tu email, parece que falta algo.';
        emailInput.focus();
        return;
      }
      err.textContent = '';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Enviando...';
    });
  }
})();
